// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2680":"757f1cdf","5478":"58fc2dd3"}[chunkId] + ".chunk.js";
};